import React, { useEffect, useId } from "react";
import styles from "./NeuralInterface.module.css";
import { NeuralInterfaceInput } from "./NeuralInterfaceInput";
import classNames from "classnames";
import { NeuralInterfaceNavigation } from "./NeuralInterfaceNavigation";
import { NeuralInterfaceContextProvider } from "./NeuralInterfaceContext";
function NeuralInterface({ documentId, activeDocumentType, isOpenRightPanel = true, isOpenLeftPanel = true, addOnGraph, onRunMethods, methods, onInitialized, saveFIle, voiceRecognize, updatesNeural, onClearUpdates }) {
    const id = useId();
    useEffect(() => {
        onInitialized();
    }, []);
    const runMethods = (data) => {
        if (documentId && activeDocumentType) {
            const methodsData = data
                .filter(({ methodId }) => methodId in methods)
                .map(({ methodId, nodesSource }) => ({
                method: methods[methodId],
                nodesSource
            }));
            onRunMethods(documentId, activeDocumentType, methodsData);
        }
    };
    const clearUpdates = (nodesSourceUpdateRecordIds) => {
        if (documentId)
            onClearUpdates(documentId, nodesSourceUpdateRecordIds);
    };
    return (React.createElement(NeuralInterfaceContextProvider, { addOnGraph: addOnGraph, runMethods: runMethods, saveFIle: saveFIle, voiceRecognize: voiceRecognize },
        React.createElement("div", { className: classNames(styles.wrapper, isOpenRightPanel && styles["right-margin"], isOpenLeftPanel && styles["left-panel"]) },
            React.createElement("div", { className: styles.container, id: id },
                React.createElement(NeuralInterfaceNavigation, { containerId: id }),
                React.createElement(NeuralInterfaceInput, { updatesNeural: updatesNeural, clearUpdates: clearUpdates })))));
}
export default NeuralInterface;
